import { HOST_STATUS } from "./constants.js";

export const formatStatusText = ({ locales, status }) => {
  const statusText = {
    [HOST_STATUS.DEAD]: locales["host.status.dead"],
    [HOST_STATUS.HURT]: locales["host.status.hurt"],
    [HOST_STATUS.OK]: locales["host.status.ok"],
  };

  return statusText[status] || status;
};
